import { CSSObject, Theme } from '@emotion/react'
import { breakpoint, calcRem, colors, themedValue } from '../../../..'

export type customStyles = 'pinned-post' | 'milestones'

/**
 * Returns Custom Styling for StyledTruncContainer based on passed styleName
 * @param styleName name of style to return eg. pinned-post
 * @param theme theme to build styles from
 */

export function getTruncatedCustomCss(
    styleName: customStyles | undefined,
    theme: Theme,
): CSSObject {
    if (!styleName) {
        return {}
    }
    switch (styleName) {
        /* Live Event Pinned Posts Custom CSS*/
        case 'pinned-post':
            return {
                margin: themedValue(theme, {
                    sevennews: calcRem(theme.margins.md, 0, theme.margins.lg),
                    fallback: calcRem(0, 0, theme.margins.sm),
                }),

                boxShadow: themedValue(theme, {
                    thewest: `0px 2px 3px rgba(0, 0, 0, 0.08)`,
                    perthnow: `0px 2px 3px rgba(0, 0, 0, 0.08)`,
                    sevennews: `0px 0px 11px rgba(0, 0, 0, 0.25)`,
                    fallback: 'none',
                }),

                [breakpoint('sm')]: {
                    margin: themedValue(theme, {
                        sevennews: theme.margins.md,
                        fallback: theme.margins.md,
                    }),

                    /* Children Container */
                    '& > div:first-of-type': {
                        marginTop: theme.margins.md * -1,
                        marginLeft: theme.margins.md * -1,
                        marginRight: theme.margins.md * -1,
                        marginBottom: 0,
                    },
                },

                [breakpoint('md')]: {
                    backgroundColor: theme.colors.palette.white,
                    boxShadow: themedValue(theme, {
                        sevennews: undefined,
                        fallback: 'none',
                    }),
                    padding: themedValue(theme, {
                        sevennews: 'inherit',
                        fallback: calcRem(theme.margins.sm, 0),
                    }),
                    margin: themedValue(theme, {
                        sevennews: calcRem(theme.margins.md, theme.margins.sm),
                        fallback: 0,
                    }),

                    borderBottom: themedValue(theme, {
                        thewest: `1px solid ${colors.thewest.greyQuokka}`,
                        perthnow: `1px solid ${colors.thewest.greyQuokka}`,
                        sevennews: 'none',
                        fallback: undefined,
                    }),

                    /* Children Container */
                    '& > div:first-of-type': {
                        marginTop: 0,
                        padding: calcRem(0, theme.margins.md),
                    },
                },
            }

        /* Live Event Milestones container Custom CSS*/
        case 'milestones':
            return {
                margin: calcRem(theme.margins.md, theme.margins.md * -1),
                button: {
                    marginLeft: themedValue(theme, {
                        sevennews: theme.margins.sm,
                        fallback: theme.margins.md,
                    }),
                },
                backgroundColor: colors.thewest.greyErmine,
                [breakpoint('md')]: {
                    margin: themedValue(theme, {
                        sevennews: calcRem(
                            theme.margins.md,
                            theme.margins.sm * -1,
                        ),
                        fallback: calcRem(
                            theme.margins.md,
                            theme.margins.md * -1,
                        ),
                    }),
                },
            }
        default:
            return {}
    }
}
